import { Component, OnInit, AfterViewInit, Input} from '@angular/core';
import {FormGroup, FormControl} from '@angular/forms';
import { GetenvironmentsService } from 'src/app/services/getenvironments.service';

import { DatePipe } from '@angular/common';
import { DataGrafica } from 'src/app/models/data-grafica';
import { DataToGraf } from 'src/app/models/data-graf';
import { DateAdapter } from '@angular/material/core';

const datePipe = new DatePipe('en-US');

//Opciones radiobutton
const temp: string = "TEMPERATURA";
const hume: string = "HUMEDAD";
const lumi: string = "LUMINOSIDAD";

//Opciones select
const disp1: string = "Disp1";
const disp2: string = "Disp2";
const disp1view: string = "Cama";
const disp2view: string = "Sillón";

interface opcionSelect {
  value: string;
  viewValue: string;
}

const today = new Date(); // Ahora
const month = today.getUTCMonth();
const year = today.getUTCFullYear();
const day  = today.getUTCDate();

@Component({
  selector: 'app-tab-datos',
  templateUrl: './tab-datos.component.html',
  styleUrls: ['./tab-datos.component.scss']
})
export class TabDatosComponent implements OnInit, AfterViewInit {

DEBUG: boolean = false;

  //IMPUTS
  @Input() arrayUser:any;

  arrayEnvironments: any;

  grafica = null;
  data = {
    graficas:[
      { text: temp, isDefault: true },
      { text: hume,  isDefault: false },
      { text: lumi,  isDefault: false }
    ]
  }

  //Arrays de datos de las gráfias
  arrayTemperatura: any = [];
  arrayHumedad: any = [];
  arrayIluminacion: any = [];

  dataChartArray = [];
  graficaSelect: string;
  flagDatos: boolean = false;
  flagDatosOption: boolean = false;
  dataGrafica: DataGrafica;
  dataToGraf: DataToGraf;
  flagCargaGrafica: boolean = true;
  // SELECT
  opcionesDisp: opcionSelect[] = [
    { value: disp1,     viewValue: disp1view},
    { value: disp2,     viewValue: disp2view}
  ];
  selectOpcion = this.opcionesDisp[0].value;
  selectedDisp = this.opcionesDisp[0].value;
  disp: string;

  //FECHA
  time: string;
  timeIni: number;
  timeFin: number;

  range = new FormGroup({
    start: new FormControl(new Date(year, month, day-1)),
    end: new FormControl(new Date(year, month, day))
  });
  
  startDate: string;
  endDate: string;

  constructor(
    private getenvironmentsService: GetenvironmentsService,
    date: DateAdapter<Date>
  ) { 
    // Inicio de la semana en lunes
    date.getFirstDayOfWeek = () => 1;

      // FECHA
    this.range = new FormGroup({
      start: new FormControl(new Date(year, month, day-1)),
      end: new FormControl(new Date(year, month, day))
    });
  }

  ngOnInit() {
    if(this.DEBUG){
      console.log("[1. TabDatosComponent] - ngOnInit");
    }
    
    //Cargamos los valores por defecto de la gráfica
    this.valuesDefaults();
    
  }

  valuesDefaults(){
    // ponemos por defecto la temperatura
    this.graficaSelect = temp;
    this.grafica = this.data.graficas.filter(this.filterDefaultSize)[0];
    // Select con el Dispositivo1
    this.disp = this.arrayUser.disp1;
    //Fecha actual de 1 dia
    this.timeIni = this.range.value.start.getTime();
    this.timeFin = new Date().getTime();
    this.time = this.timeIni + '-' + this.timeFin;
    
    this.flagDatosOption = true;
  }

  private filterDefaultSize(element){
    return (element.isDefault == true);
  }

  ngAfterViewInit() {

  }

  onOptionradioSelected(grafica) {
    // Capturamos el cambio y cargamos una nueva gráfica
    this.graficaSelect = grafica.text;
  } 


  onOptionSelected() {
    switch(this.selectOpcion) { 
      case "Disp1": { 
          // CARGAMOS LOS DATOS DEL DISPOSITIVO-1
          this.disp = this.arrayUser.disp1;
          // this.asyncMethodEnvironments(this.disp);
        break; 
     } 
      case "Disp2": { 
          // CARGAMOS LOS DATOS DEL DISPOSITIVO-2
          this.disp = this.arrayUser.disp2;
          // this.asyncMethodEnvironments(this.disp);
         break; 
      } 
      default: { 
        //statements; 
        break; 
      } 
    }
  }

  // SELECTOR DE FECHA
  dateSelected() { 
    let today = new Date(); 
    let todayString: string;
    // Rango de fechas Timestamp
    this.timeIni = this.range.value.start.getTime();
    this.timeFin = this.range.value.end.getTime();

    this.time = this.timeIni + '-' + this.timeFin;

    //Rango de fechas normal
    todayString = datePipe.transform(today, 'd MM YYY');
    this.startDate = datePipe.transform(this.timeIni, 'd MM YYY');
    this.endDate = datePipe.transform(this.timeFin, 'd MM YYY');
    
    if(todayString == this.endDate){
      this.timeFin = new Date().getTime();
    }

    if(this.DEBUG){
      console.log("Fecha Hoy:" + today);
      console.log("START: " + this.startDate);
      console.log("END: " + this.endDate);
    }

  }

  cargarGrafica(){
    //Grafica seleccionada
    this.flagCargaGrafica = false;
    if(this.DEBUG){
      console.log("CARGAR GRAFICA CON LAS OPCIONES MOSTRADAS");
      console.log("Dispositivo: "); console.log(this.disp);
      console.log("Tipo de Grafica: "); console.log(this.graficaSelect);
      console.log("timeIni: "); console.log(this.timeIni);
      console.log("timeFin: "); console.log(this.timeFin);
    }

    if(this.timeIni == this.timeFin){
      this.timeFin = this.timeFin + 86400000; //Sumamos 24h
    }
    this.asyncMethodEnvironments(this.disp);
  }

    // OBTENCION DE LOS DATOS SEGUN LA FECHA
    async asyncMethodEnvironments(disp: string) {
  
      this.arrayEnvironments = await this.getenvironmentsService.getEnvironments(disp, this.timeIni, this.timeFin);

      if(this.DEBUG){
        console.log("SERVICE ENVIRONMENTS: ");
        console.log (this.arrayEnvironments);
      }

      if(this.arrayEnvironments.length == 0){
        alert("No hay datos ambientes del dispositivo seleccionado");
      }else{
          // Cargamos los datos en las gráficas
        switch(this.graficaSelect) { 
          case temp: { 
             //TEMPERATURA
             let temperaturaAux: any = [];
             let timestampAux: any = [];

             for (let i = 0; i < this.arrayEnvironments.length; i++) {
              if(this.arrayEnvironments[i].temperatura != undefined){
                temperaturaAux.push(this.arrayEnvironments[i].temperatura);
                timestampAux.push(this.arrayEnvironments[i].timestamp);
              }
            }

            this.dataToGraf = {
              data: temperaturaAux,
              timestamp: timestampAux

            };
            if(this.DEBUG){
              console.log(this.dataToGraf);
            }
            //rellenamos los datos a enviar a la gráfica;
            this.dataGrafica = {
              data: this.dataToGraf,
              timeIni: this.timeIni,
              timeFin: this.timeFin,
              tipoGrafica: this.graficaSelect
            }
            if(this.DEBUG){
              console.log(this.dataGrafica);
            }
              this.flagDatos = true;
             break; 
          } 
          case hume: { 
             //HUMEDAD
             let humedadAux: any = [];
             let timestampAux: any = [];
             this.dataGrafica

             for (let i = 0; i < this.arrayEnvironments.length; i++) {
              if(this.arrayEnvironments[i].humedad != undefined){
                humedadAux.push(this.arrayEnvironments[i].humedad);
                timestampAux.push(this.arrayEnvironments[i].timestamp);
              }
            }

            this.dataToGraf = {
              data: humedadAux,
              timestamp: timestampAux

            };
            if(this.DEBUG){
              console.log(this.dataToGraf);
            }
          
            //rellenamos los datos a enviar a la gráfica;
            this.dataGrafica = {
              data: this.dataToGraf,
              timeIni: this.timeIni,
              timeFin: this.timeFin,
              tipoGrafica: this.graficaSelect
            }
            if(this.DEBUG){
              console.log(this.dataGrafica);
            }
            
             this.flagDatos = true;
          
             break; 
          } 
          case lumi: { 
            //LUMINOSIDAD; 
            let iluminacionAux: any = [];
            let timestampAux: any = [];
            this.dataGrafica

            for (let i = 0; i < this.arrayEnvironments.length; i++) {
             if(this.arrayEnvironments[i].humedad != undefined){
              iluminacionAux.push(this.arrayEnvironments[i].iluminacion);
               timestampAux.push(this.arrayEnvironments[i].timestamp);
             }
           }

           this.dataToGraf = {
             data: iluminacionAux,
             timestamp: timestampAux

           };
           if(this.DEBUG){
            console.log(this.dataToGraf);
          }
         
           //rellenamos los datos a enviar a la gráfica;
           this.dataGrafica = {
             data: this.dataToGraf,
             timeIni: this.timeIni,
             timeFin: this.timeFin,
             tipoGrafica: this.graficaSelect
           }
           if(this.DEBUG){
            console.log(this.dataGrafica);
          }
            this.flagDatos = true;
          
            break; 
         } 
          default: { 
            //statements; 
            break; 
          } 
        }
          }
      
    }


}
